//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseCmsBlock from "../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin";

export default BaseCmsBlock.extend({
  name: "PartnerHeadingBlock",

  methods: {
    toBlock: function (name) {
      const element = document.getElementById(name);
      if (!element) {
        return
      }

      const posTop = document.getElementById('scroll-container')?.scrollTop || 0;
      const position = element.getBoundingClientRect().top;

      document.getElementById('scroll-container').scrollTo({
        top: posTop + position - 120
      });
    }
  }
})
